export default __webpack_public_path__ + "static/supporting-our-team-a40600c5d63d9c5cca963a3c31b93f1f.webm";